import React from 'react';
import UserDashboard from '../components/UserDashboard';
import { DebugLabel } from '../components/shared';
import { useAuth } from '../contexts/AuthContext';
import { useMetaTags } from '../hooks/useMetaTags';
import { MainLayout } from '../layouts/MainLayout';

export const DashboardPage: React.FC = () => {
  const { user: firebaseUser, dbProfile } = useAuth();
  useMetaTags({
    title: 'Insights | Smart Prompt',
    url: 'https://www.smartprompt.us/dashboard'
  });

  // Map Firebase user to dashboard user format
  const dashboardUser = firebaseUser ? {
    id: firebaseUser.uid,
    email: firebaseUser.email || '',
    displayName: firebaseUser.displayName || 'User',
    subscriptionTier: (dbProfile?.subscriptionTier || 'free') as 'free' | 'pro' | 'team' | 'enterprise'
  } : undefined;

  return (
    <MainLayout>
      <div className="relative">
        <DebugLabel label="DashboardPage-Container" type="page" position="top-left" />
        <DebugLabel label="Dashboard-UserDashboardComponent" type="component" position="top-right" />
        <UserDashboard user={dashboardUser} />
      </div>
    </MainLayout>
  );
};
